import React, { useState } from 'react';
import { BookOpen, Trophy, Check } from 'lucide-react';
import { trackFbEvent } from '../lib/fbPixel';
import { CHECKOUT_PRO, CHECKOUT_ELITE } from '../lib/checkout';
interface Plan {
  id: 'pro' | 'elite';
  name: string;
  icon: typeof BookOpen;
  contents: React.ReactNode;
  priceOld: string;
  price: string;
  cta: string;
  url: string;
  featured?: boolean;
}
const PLANS: Plan[] = [{
  id: 'pro',
  name: 'PACK PROFESIONAL',
  icon: BookOpen,
  contents: '14 Tomos + 6 Bonus',
  priceOld: '$29.990',
  price: '$18.990',
  cta: 'Quiero el Pack Profesional',
  url: CHECKOUT_PRO
}, {
  id: 'elite',
  name: 'MEGAPACK ÉLITE',
  icon: Trophy,
  contents: <>
        14 Tomos + 6 Bonus +{' '}
        <span className="font-bold text-slate-900" data-id="element-11">2 EBOOKS ÉLITE</span>
      </>,
  priceOld: '$49.990',
  price: '$27.990',
  cta: 'SÍ, QUIERO EL MEGAPACK ÉLITE →',
  url: CHECKOUT_ELITE,
  featured: true
}];
export function PricingSelector() {
  const [selected, setSelected] = useState<'pro' | 'elite'>('elite');
  const active = PLANS.find(p => p.id === selected)!;
  return <div className="max-w-xl mx-auto bg-white text-slate-900 rounded-3xl p-6 md:p-8 shadow-2xl" data-id="element-12">
      <div className="space-y-4" data-id="element-13">
        {PLANS.map(plan => {
        const isSelected = selected === plan.id;
        const Icon = plan.icon;
        return <button key={plan.id} type="button" onClick={() => setSelected(plan.id)} aria-pressed={isSelected} className={`w-full text-left rounded-2xl border-2 p-5 transition-all flex items-start gap-4 ${isSelected ? 'border-green-500 bg-green-50' : 'border-slate-200 bg-white hover:border-slate-300'}`} data-id="element-14">
              {/* Radio */}
              <span className={`mt-1 flex-shrink-0 w-6 h-6 rounded-full border-2 flex items-center justify-center transition-colors ${isSelected ? 'border-green-600 bg-green-600' : 'border-slate-300'}`} data-id="element-15">
                {isSelected && <Check className="w-4 h-4 text-white" strokeWidth={3} data-id="element-16" />}
              </span>

              <div className="flex-1 min-w-0" data-id="element-17">
                <div className="flex items-start justify-between gap-3" data-id="element-18">
                  <div className="min-w-0" data-id="element-19">
                    <h3 className="font-black text-lg leading-tight flex items-center gap-2" data-id="element-20">
                      <Icon className={`w-5 h-5 flex-shrink-0 ${plan.featured ? 'text-yellow-500' : 'text-slate-400'}`} data-id="element-21" />
                      {plan.name}
                    </h3>
                    {plan.featured && <div className="flex flex-wrap gap-2 mt-2" data-id="element-22">
                        <span className="inline-block bg-yellow-400 text-yellow-950 text-[11px] font-black px-3 py-1 rounded-full uppercase tracking-wide" data-id="element-23">
                          ⭐ Más elegido
                        </span>
                        <span className="inline-block bg-green-600 text-white text-[11px] font-black px-3 py-1 rounded-full uppercase tracking-wide" data-id="element-24">
                          Ahorrás $22.000
                        </span>
                      </div>}
                  </div>
                  <div className="text-right flex-shrink-0" data-id="element-25">
                    <div className="text-slate-400 line-through text-sm" data-id="element-26">
                      {plan.priceOld}
                    </div>
                    <div className={`text-2xl md:text-3xl font-black ${plan.featured ? 'text-green-600' : 'text-slate-900'}`} data-id="element-27">
                      {plan.price}
                    </div>
                  </div>
                </div>
                <p className="text-slate-500 text-sm mt-2" data-id="element-28">{plan.contents}</p>
              </div>
            </button>;
      })}
      </div>

      {/* Single dynamic CTA */}
      <a href={active.url} onClick={() => trackFbEvent('InitiateCheckout', {
      content_name: active.name,
      value: Number(active.price.replace(/[^0-9]/g, '')),
      currency: 'ARS'
    })} className="block w-full mt-6 py-5 text-center font-black text-white bg-green-600 hover:bg-green-500 rounded-2xl transition-all text-lg md:text-xl shadow-lg shadow-green-600/30" data-id="element-29">
        {active.cta}
      </a>

      <p className="text-center text-sm text-slate-400 italic mt-4" data-id="element-30">
        La opción más elegida por entrenadores de futsal argentinos
      </p>
    </div>;
}